import { t } from "../js/filters";

const getPageUri = (url, locale) => {
  const origin = window.location.hostname;
  const baseUrl = `${origin}/${locale !== "nl" ? locale : ""}`;

  // Check if the URL is a valid URL and doesn't contain the base URL
  try {
    const parsedUrl = new URL(url);
    if (!url.includes(baseUrl)) {
      return url;
    }

    // If the URL contains the base URL, return the path part
    return parsedUrl.pathname.replace(/^\/|\/$/g, "");
  } catch (e) {
    // If it's not a valid URL, treat it as a path/slug and clean it up
    return url.replace(/^\/|\/$/g, "");
  }
};

export const getAriaLinkText = (url) => {
  if (!url) {
    return null;
  }

  const path = window.location.pathname;
  let locale = "nl";

  if (path && ["en", "de"].includes(path.split("/")[1])) {
    locale = path.split("/")[1];
  }
  const uri = getPageUri(url, locale);

  const translations = {
    nl: "Ga naar ",
    en: "Go to ",
    de: "Gehe zu ",
  };
  const text = translations[locale] || "";

  if (!uri) {
    return;
  }

  return text + uri;
};

export const setCookie = (name, value, days) => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000); // Convert days to milliseconds
  document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
};

export const getCookie = (name) => {
  const nameEQ = `${name}=`;
  const cookies = document.cookie.split(";");
  for (let cookie of cookies) {
    cookie = cookie.trim();
    if (cookie.indexOf(nameEQ) === 0) {
      return cookie.substring(nameEQ.length);
    }
  }
  return null;
};

export const deleteCookie = (name) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
};

export const userDeviceHasHover = () => {
  return !window.matchMedia("(any-hover: none)").matches;
};

export const mainNavigationHeight = () => {
  const navigation = document.querySelector(".navigation-mobile");

  if (!navigation) {
    return 0;
  }

  return navigation.offsetHeight;
};

const stringToUri = (string) => {
  return string.replace(/[^\w]|_/g, "-").toLowerCase();
};

const setLanguageUrl = (lang) => {
  switch (lang) {
    case "EN":
      return "/en/service-and-contact/question/";
    case "DE":
      return "/de/service-und-kontakt/fragen/";
    case "NL":
      return "/service-en-contact/vraag/";
    default:
      return "/service-en-contact/vraag/";
  }
};

export const createLink = (title, id, lang) => {
  const url = window.location.origin;
  const language = setLanguageUrl(lang);
  return `${url}${language}${id}/${stringToUri(title)}`;
};

export const transformSearchResults = (items) => {
  return items.map((item) => {
    return {
      id: item.objectID,
      title: item.title,
      tag: item.searchCategories,
      url: item.url,
      target: item.type === "eventExternal" ? "_blank" : "_self",
    };
  });
};

export const getResultsMessage = (number, query = null) => {
  if (number === 0 && !query) {
    return "";
  }

  if (number === 0) {
    return t("0 results found for '{query}'", {
      params: { query },
    });
  }

  if (number === 1 && query) {
    return t("1 result for '{query}'", {
      params: { query },
    });
  }

  if (number > 1 && query) {
    return t("{number} results for '{query}'", {
      params: { number, query },
    });
  }

  if (number === 1) {
    return t("1 result");
  }

  return t("{number} results", {
    params: { number },
  });
};
